<template>
  <div v-clickoutside="handleClose" class="gem-capital" v-if="noHeader">
    <div class="gem-select__tags" @click.stop="toggle" :style="{ 'max-width': inputWidth - 32 + 'px' }" :class="{'gem-select__noChange':noChange}">
      <span class="gem-tag" v-for="(item, index) in trimSelected" :key="index">
        <span class="el-select__tags-text">{{ optionsMap[item]}}</span>
        <i class="gem-tag__close el-icon-close" @click.stop="deleteTag(index)"></i>
      </span>
      <span style="color: var(--text-title-color);" v-if="isCollapsed && this.value.length != 0">...</span>
    </div>
    <div ref="gemHidden" class="gem-select__tags__hidden" :style="{ 'max-width': inputWidth - 32 + 'px' }">
      <span ref="hiddenContent">
        <span class="gem-tag" v-for="(item, index) in selected" :key="index">
          <span class="el-select__tags-text">{{ optionsMap[item]}}</span>
          <i class="gem-tag__close el-icon-close"></i>
        </span>
      </span>
    </div>
    <el-input readonly :placeholder="currentPlaceholder" ref="reference" @click.native="toggle" :disabled="noChange">
      <i slot="suffix" :class="['el-select__caret', 'el-input__icon', 'el-icon-arrow-up', iconClass]"></i>
    </el-input>
    <transition name="el-zoom-in-top">
      <industry-menu @change='onSelect' ref="popper" :visible-arrow="false" v-show="visible">
      </industry-menu>
    </transition>
  </div>
  <div v-else>
    <industry-menu @change='onSelect' ref="popper" v-show="visible">
    </industry-menu>
  </div>
</template>
<script>
import IndustryMenu from './searchMenu.vue';
import Clickoutside from 'element-ui/lib/utils/clickoutside';

export default {
  components: {
    IndustryMenu
  },
  directives: { Clickoutside },
  provide() {
    return {
      select: this
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$refs.popper.destroyPopper();
      } else {
        this.$refs.popper.updatePopper();
      }
    },
    value(val) {
      this.calculateSelected();
    },
  },
  data() {
    return {
      visible: false,
      inputWidth: 0,
      trimSelected: [],
      selected: [],
      i: 0,
      shouldReturn: false,
      noChange:false,
    };
  },
  computed: {
    iconClass() {
      if (this.visible) {
        return 'is-reverse';
      } else {
        return '';
      }
    },
    currentPlaceholder() {
      if (this.value.length == 0) {
        return this.placeholder;
      } else {
        return '';
      }
    },
    isCollapsed() {
      return this.value.length != this.trimSelected.length;
    },
    optionsMap() {
      let ret = {};
      for (let i = 0; i < this.options.length; i++) {
        let item = this.options[i];
        ret[item.value] = item.label;
      }
      return ret;
    }
  },
  props: {
    value: {
      default() {
        return [];
      }
    },
    options: {
      default() {
        return [];
      }
    },
    placeholder: {
      default: '全部'
    },
    noHeader: {
      default: true
    },
  },
  methods: {
    toggle() {
      if(!this.isPerson && this.role!=='root'&&this.role!=='customer'&&this.role!=='manager'){
        this.visible = !this.visible;
      }
    },
    peosonInit(){
      this.visible= false;
      this.noChange =true;
      let value = ["all"];
      this.onSelect(value);
    },
    handleClose() {
      this.visible = false;
    },
    resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },

    handleResize() {
      this.resetInputWidth();
    },
    deleteTag(index) {
      let role = this.role;
      if(role!=='person'&&role!=='root'&&role!=='customer'&&role!=='manager'){
        let arr = this.value;
        arr.splice(index, 1);
        this.$emit('input', arr);
      }
    },
    onSelect(value) {
       /* console.log(value);*/
      this.$emit('input', value);
    },
    calculateSelected() {
      if (this.i > this.value.length || this.shouldReturn) {
        if (this.i === 1) {
          this.trimSelected = this.value.slice(0, 1);
        } else {
          this.trimSelected = this.value.slice(0, this.i - 1);
        }
        this.i = 0;
        this.shouldReturn = false;
        return;
      }
      this.selected = this.value.slice(0, this.i);
      this.$nextTick(() => {
        if (this.$refs.hiddenContent) {
          if (this.$refs.gemHidden) {
            let content = this.$refs.hiddenContent.getBoundingClientRect()
              .width;
            let wrap = this.$refs.gemHidden.getBoundingClientRect().width;
            if (content > wrap) {
              this.shouldReturn = true;
            } else {
              this.i++;
            }
            this.calculateSelected();
          }
        }
      });
    }
  },
  mounted() {
    let role = this.role;
    /*console.log(this.options)*/
    if(role==='person'||role==='root'||role==='customer'||role==='manager'){
        this.peosonInit();
    }
    window.addEventListener('resize', this.handleResize);
    this.$nextTick(() => {
      if (this.$refs.reference && this.$refs.reference.$el) {
        this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
      }
    });
    this.calculateSelected();
  },
  beforeDestroy() {
    if (this.$el && this.handleResize)
      window.removeEventListener('resize', this.handleResize);
  }
};
</script>
<style lang="scss" scoped>
.gem-capital {
  position: relative;
  .el-select__caret {
    transition: transform 0.3s, -webkit-transform 0.3s;
    transform: rotateZ(180deg);
    &.is-reverse {
      transform: rotateZ(0);
    }
  }
  .gem-tag__close.el-icon-close {
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: 12px;
    height: 16px;
    width: 16px;
    line-height: 16px;
    vertical-align: middle;
    background-color: #c0c4cc;
    right: -4px;
    top: 0;
    margin-top: -2px;
    color: #fff;
    transform: scale(0.8);
    &::before {
      display: block;
      transform: translateY(0.5px);
    }
    &:hover {
      background-color: var(--text-title-color);
    }
  }
}

.gem-select__tags,
.gem-select__tags__hidden {
  position: absolute;
  line-height: normal;
  white-space: normal;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
}
.gem-select__noChange{
  pointer-events: none;
}
.gem-select__tags__hidden {
  visibility: hidden;
}
.gem-tag {
  box-sizing: border-box;
  border-color: transparent;
  margin: 3px 0 3px 6px;
  background-color: #f0f2f5;
  height: 24px;
  padding: 0 8px;
  line-height: 24px;
  display: inline-block;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  color: var(--text-title-color);
}
</style>





// WEBPACK FOOTER //
// src/components/search/searchTable/select.vue